<!-- eslint-disable -->
<template lang="pug">
        cs-modal(@close="$emit('close')", :is-blur="true")
                div(v-if="!this.successfullyAdded")
                        .miles-modal__header(slot="header")
                                | {{ $i18n.t('miles.miles_modal_milesChanging') }}
                        form.miles-modal__form(action="javascript://" @submit="updateMiles")
                                .miles-modal__item.miles-modal__text
                                        | {{ user.fullName }}
                                        | {{ milesString }}
                                cs-input.miles-modal__input(
                                        type="number"
                                        onkeydown="if (`${this.value}`.length >= 9 && event.keyCode !== 8) return false;"
                                        :placeholder="$i18n.t('miles.miles_modal_inputPlaceholder')"
                                        v-model.number="miles"
                                        v-validate="'required|max:9'"
                                        v-focus="true"
                                        name="number"
                                        :data-vv-as="$i18n.t('miles.miles_modal_milesCount')"
                                )
                                help-text(v-if="errors.has('number')" :error="errors.has('number')")
                                        | {{ errors.first('number') }}
                                .miles-modal__item.miles-modal__text--big
                                        | {{ $i18n.t('miles.miles_modal_total') }} {{ total }}
                                .miles-modal__buttons
                                        router-link.miles-modal__link(
                                                :to="routerObject"
                                        ) {{ $i18n.t('miles.miles_modal_milesChangingHistory') }}
                                        cs-button.miles-modal__button(
                                                color="blue"
                                                :loading="isLoading"
                                                :disabled="errors.has('number')"
                                                @click.prevent="updateMiles"
                                        ) {{ $i18n.t('miles.miles_modal_scoreMiles') }}
                .miles-modal__add-miles_container(v-else)
                        span
                                svg-icon.miles-modal__add-miles_successfully-added(name="check", size="xx-large")
                        span.miles-modal__add-miles_text
                                | {{ $i18n.t('miles.miles_modal_milesWasAdd') }}
</template>

<script>
    /*eslint-disable*/
    import UserApi from '../api/user/user'

    import CsModal from '../elements/CsModal.vue'
    import HelpText from '../elements/HelpText.vue'

    import {mapState} from 'vuex'

    export default {
        props: {
            user: Object,
        },
        components: {HelpText, CsModal},
        data () {
            return {
                isLoading: false,
                miles: 0,
                successfullyAdded: false
            }
        },
        mounted() {
            this.$validator.validateAll();
        },
        methods: {
            updateMiles () {
                this.$validator.validateAll()
                    .then(response => {
                        if (response && this.miles) {
                            this.isLoading = true;
                            this.$emit('miles', +this.miles);
                            return UserApi.updateMiles(this.user.id, this.miles)
                        }
                    })
                    .then(() => {
                        this.isLoading = false;
                        if (this.authUser.type === 'teacher') {
                            this.$toasted.success(this.$i18n.t('miles.miles_modal_requestWasSend'));
                        } else if (this.miles > 0) {
                            this.$toasted.success(this.$i18n.t('miles.miles_modal_milesWasAdd'));
                        } else {
                            this.$toasted.success(this.$i18n.t('miles.miles_modal_milesWasRemove'));
                        }
                        this.successfullyAdded = !this.successfullyAdded;
                        setTimeout(() => {this.$emit('close');}, 5000)
                    })
                    .catch(() => {
                        this.isLoading = false;
                    })
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user
            }),
            routerObject () {
                let route;
                if (this.$isDetectiveAvailable && this.$isMapAvailable) {
                    route = {name: 'histories-progress', params: {type: 'miles'}}
                } else if (this.$isMapAvailable) {
                    route = {name: 'miles-history:list', params: {type: 'miles-history'}};
                }
                Object.assign(route, {
                    query:
                        {
                            schoolId: this.user.grades[0] && this.user.grades[0].schoolId,
                            gradeId: this.user.grades[0] && this.user.grades[0].id,
                            userId: this.user.id
                        }
                });
                return route;
            },
            milesString () {
                return '(' + this.user.miles + ' '
                    + this.$i18n.tc('miles.miles_modal_milesDeclination', this.user.miles) + ')';
            },
            total () {
                const miles = this.user.miles + this.miles;
                return miles + ' ' + this.$i18n.tc('miles.miles_modal_milesDeclination', miles);
            },
        }
    }
</script>

<style lang="scss" scoped>
        .miles-modal__header {
            font-size: 22px;
            font-weight: 500;
        }
		.miles-modal__form {
				margin-top: 25px;
				text-align: left;
		}

		.miles-modal__input {
				margin-top: 10px;
				&::-webkit-inner-spin-button,
				&::-webkit-outer-spin-button{
						appearance: none;
						margin: 0;
				}
		}

		.miles-modal__item {
				margin-top: 10px;
		}

		.miles-modal__text {
				font-weight: 500;
				font-size: 16px;
				line-height: 19px;
		}

		.miles-modal__text--big {
				font-weight: 500;
				font-size: 18px;
				line-height: 21px;
		}

		.miles-modal__buttons {
				margin-top: 15px;
				display: flex;
				flex-direction: column;
				@include media($md) {
						flex-direction: row;
						align-items: center;
						justify-content: space-between;
				}
		}

		.miles-modal__link {
				color: $hsl-color-blue-56;
				text-decoration: underline;
				margin-bottom: 20px;
				@include media($md) {
						margin-bottom: 0;
				}
		}

		.miles-modal__link:hover {
				color: $hsl-color-blue-56;
				text-decoration: none;
		}

		.miles-modal__button {
				max-width: 200px;
				@include media($md) {
						max-width: none;
				}
		}

        .miles-modal__add-miles_container {
                display: flex;
                flex-direction: column;
        }

        .miles-modal__add-miles_successfully-added {
                border-radius: 50%;
                color: $hsl-color-green-58;
                border: 4px solid $hsl-color-green-58;
                padding: 8px;
                margin-bottom: 20px;
        }

        .miles-modal__add-miles_text {
                font-size: 22px;
                font-weight: 500;
        }
</style>
